var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_11853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 15.6C9.96039 15.6 8.40039 17.16 8.40039 19.2V24H15.6004V19.2C15.6004 17.16 14.0404 15.6 12.0004 15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4004 9.72V1.2C20.4004 0.48 19.9204 0 19.2004 0C18.4804 0 18.0004 0.48 18.0004 1.2V6.96C17.2804 6.36 16.4404 5.88 15.4804 5.52C15.6004 5.28 15.6004 5.04 15.6004 4.8C15.6004 2.76 14.0404 1.2 12.0004 1.2C9.96039 1.2 8.40039 2.76 8.40039 4.8C8.40039 5.04 8.40039 5.28 8.52039 5.52C7.56039 5.88 6.72039 6.36 6.00039 6.96V1.2C6.00039 0.48 5.52039 0 4.80039 0C4.08039 0 3.60039 0.48 3.60039 1.2V9.96C2.88039 11.4 2.40039 12.96 2.40039 14.76V22.8C2.40039 23.52 2.88039 24 3.60039 24H6.00039V19.44C6.00039 16.32 8.28039 13.56 11.4004 13.2C15.0004 12.84 18.0004 15.6 18.0004 19.2V24H20.4004C21.1204 24 21.6004 23.52 21.6004 22.8V14.4C21.6004 12.72 21.1204 11.16 20.4004 9.72ZM12.0004 3.6C13.3204 3.48 13.2004 4.8 13.2004 4.92C12.6004 4.8 12.0004 4.8 11.2804 4.8C11.1604 4.8 11.0404 4.92 10.8004 4.92C10.8004 4.8 10.8004 3.6 12.0004 3.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_11853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.142737edde97d4c3804f5a1513ac922b.svg";
export { ForwardRef as ReactComponent };